import React from 'react';
import { HStack, Image, Text, useColorModeValue } from '@chakra-ui/react';

import { SmartAmpStatus } from './smart-amp-sse-helpers';

const COLOR_GREEN_TEXT = '#179332';
const COLOR_RED_TEXT = '#BA3430';
const COLOR_GREEN_TEXT_DARK = '#3DCD57';
const COLOR_RED_TEXT_DARK = '#FF8A80';

interface SmartDeviceStatusProps {
  name: string;
  iconSrc: string;
  status: SmartAmpStatus;
  statusLabel: string;
}

export function SmartDeviceStatus({ name, iconSrc, status, statusLabel }: SmartDeviceStatusProps) {
  const inactiveStatusColor = useColorModeValue('gray.500', 'white');
  const activeStatusColor = useColorModeValue(COLOR_GREEN_TEXT, COLOR_GREEN_TEXT_DARK);
  const alertStatusColor = useColorModeValue(COLOR_RED_TEXT, COLOR_RED_TEXT_DARK);

  return (
    <HStack justify="space-between" align="center" w="100%">
      <HStack spacing={2}>
        {iconSrc && <Image src={iconSrc} alt={`${name} icon`} boxSize="32px" />}
        <Text fontSize="lg">{name}</Text>
      </HStack>
      <Text
        fontWeight="bold"
        fontSize="sm"
        color={status === 'inactive' ? inactiveStatusColor : status === 'active' ? activeStatusColor : alertStatusColor}
        letterSpacing="wide"
        data-testid="smart-device-status"
      >
        {statusLabel}
      </Text>
    </HStack>
  );
}
